var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTounamentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.54492 19.2725C8.54492 19.5738 8.78913 19.818 9.09036 19.818H14.9084C15.2096 19.818 15.4538 19.5738 15.4538 19.2725C15.4538 17.0829 14.0145 15.0908 11.9994 15.0908C9.98424 15.0908 8.54492 17.0829 8.54492 19.2725Z",
    fill: "#FF9355"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 6.90938C16 6.50773 16.3256 6.18213 16.7272 6.18213H19.2726C19.4835 6.18213 19.6839 6.27361 19.822 6.43288C19.9602 6.59215 20.0223 6.80352 19.9925 7.01223L19.8192 8.22598C19.8134 8.26633 19.8077 8.30619 19.8021 8.34557C19.6273 9.57056 19.5176 10.3392 19.2067 11.0146C18.8721 11.7413 18.371 12.3788 17.7441 12.8756C17.1613 13.3374 16.4403 13.6257 15.2913 14.085C15.2544 14.0998 15.217 14.1147 15.1792 14.1299C14.8063 14.279 14.383 14.0976 14.2338 13.7247C14.0847 13.3518 14.2661 12.9285 14.639 12.7794C15.9373 12.2601 16.4449 12.0493 16.8408 11.7356C17.2886 11.3808 17.6465 10.9254 17.8855 10.4063C18.0967 9.94764 18.1815 9.40452 18.3793 8.02029L18.4341 7.63663H16.7272C16.3256 7.63663 16 7.31103 16 6.90938Z",
    fill: "#FF9355"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.17785 6.43288C4.31598 6.27361 4.51644 6.18213 4.72726 6.18213H7.27265C7.67429 6.18213 7.9999 6.50773 7.9999 6.90938C7.9999 7.31103 7.67429 7.63663 7.27265 7.63663H5.56579L5.6206 8.02029C5.81834 9.40452 5.90319 9.94764 6.1144 10.4064C6.35335 10.9254 6.71127 11.3808 7.15909 11.7357C7.55492 12.0493 8.0626 12.2602 9.36087 12.7794C9.7338 12.9286 9.91519 13.3518 9.76601 13.7248C9.61685 14.0977 9.19361 14.2791 8.82069 14.1299C8.78285 14.1148 8.74547 14.0998 8.70852 14.0851C7.55955 13.6257 6.83855 13.3374 6.25577 12.8756C5.62881 12.3789 5.12774 11.7413 4.79319 11.0147C4.48223 10.3393 4.37256 9.57056 4.19778 8.34557C4.19215 8.30619 4.18647 8.26632 4.18071 8.22598L4.00731 7.01223C3.9775 6.80352 4.03972 6.59215 4.17785 6.43288Z",
    fill: "#FF9355"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.73881 5.47107C6.7183 4.75288 7.3015 4.18213 8.00092 4.18213H16.0007C16.7001 4.18213 17.2833 4.75288 17.2629 5.47107C17.1801 8.36759 16.6169 10.9891 15.7329 12.9063C14.8725 14.7726 13.5996 16.1818 12.0008 16.1818C10.402 16.1818 9.12914 14.7726 8.26868 12.9063C7.38473 10.9891 6.82149 8.36759 6.73881 5.47107Z",
    fill: "#FF9355"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTounamentIcon);
export default __webpack_public_path__ + "static/media/tounament-icon.1fcf7e1f47a66a3bd24e27c518b414b4.svg";
export { ForwardRef as ReactComponent };